// src/components/Icon.jsx
import React from "react";

const Icon = ({ id, size = 24, color = "currentColor", className = "" }) => {
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className="icon"
            aria-hidden="true"
        >
            <use xlinkHref={`#${id}`} />
        </svg>
    );
};

export default Icon;
